<template>
  <div id="vue-app">

      <!-- Breadcrumbs -->
      <nav class="breadcrumb">
          <a href="/">HOME</a><span class="divider">/</span>
          <router-link to="/available-properties/">Available Properties</router-link><span class="divider">/</span>{{ propertyData.ppn }}
        </nav>
    <!-- end Breadcrumbs -->

    <!-- Desktop Grid/Map links, share links -->
      <div class="top-links desktop">
        <div class="view-links">
            <button class="link uppercase" v-focus @click="goToGrid">
            <svg height="28" viewBox="0 0 30 28" width="30" xmlns="http://www.w3.org/2000/svg"><g fill="#276aa6" fill-rule="evenodd"><path d="m0 0h6v6h-6z"/><path d="m12 0h6v6h-6z"/><path d="m24 0h6v6h-6z"/><path d="m0 11h6v6h-6z"/><path d="m12 11h6v6h-6z"/><path d="m24 11h6v6h-6z"/><path d="m0 22h6v6h-6z"/><path d="m12 22h6v6h-6z"/><path d="m24 22h6v6h-6z"/></g></svg>
            Back to Properties List
            </button>
            <!-- <a class="link uppercase" :href="'/available-properties/#map'">
            <svg height="32" viewBox="0 0 22 32" width="22" xmlns="http://www.w3.org/2000/svg"><path d="m11.001 1.072c5.291 0 9.596 4.305 9.596 9.597 0 1.683-.446 3.341-1.29 4.799l-8.307 14.394-8.308-14.395c-.843-1.456-1.289-3.115-1.289-4.798 0-5.292 4.305-9.597 9.597-9.597zm0 13.328c2.058 0 3.731-1.674 3.731-3.731s-1.674-3.731-3.731-3.731c-2.058 0-3.732 1.674-3.732 3.731s1.674 3.731 3.732 3.731zm0-14.394c-5.889 0-10.663 4.775-10.663 10.663 0 1.945.523 3.762 1.432 5.332l9.23 15.994 9.23-15.994c.909-1.57 1.432-3.387 1.432-5.332 0-5.888-4.774-10.663-10.662-10.663zm0 13.328c-1.472 0-2.666-1.193-2.666-2.665 0-1.471 1.194-2.665 2.666-2.665s2.665 1.194 2.665 2.665c0 1.472-1.193 2.665-2.665 2.665z" fill="#276aa6" transform=""/></svg>
            Back to Map Results
            </a> -->
        </div>
        <div class="share-links">
          <div class="share-link uppercase" v-clipboard:copy="copyURL" v-on:click="alerts()">
              <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><g fill="#dc3b43" transform=""><path d="m13.5670709 7.61102408c-.2634256-.28097325-.5555127-.53003655-.8708331-.74263135-.8351799-.56705761-1.8061112-.86838323-2.79784389-.86838323-1.37649214-.00271672-2.69705084.57718775-3.66867702 1.61101458l-4.7136941 5.00194082c-.96997597 1.0304654-1.51515318 2.4266289-1.51602172 3.8825142-.00182391 3.0381211 2.31941335 5.5025539 5.18469873 5.5044878 1.37436423.0050651 2.69370699-.5720766 3.66498576-1.6031407l3.89102104-4.1257297c.0706985-.0743184.1101733-.1757119.1096087-.2812495-.0011725-.2170152-.1680608-.3918983-.3727303-.390655h-.1482149c-.8129455.003039-1.6186387-.1624967-2.37165549-.4872137-.13874791-.0605506-.29821029-.0263844-.40391057.0864285l-2.79784392 2.9705254c-.86879205.9211981-2.27737642.9211981-3.14616847 0s-.86879205-2.4147491 0-3.3359472l4.73223725-5.01372856c.86809723-.91931019 2.27438-.91931019 3.1424772 0 .5850428.58381836 1.4976089.58381836 2.0826082 0 .2517005-.26711337.4043015-.62139199.4298797-.99804901.0270548-.45010054-.129498-.89089976-.4299231-1.21018335z"/><path d="m20.4811951 1.61125696c-2.0250948-2.14834261-5.3084248-2.14834261-7.3335197 0l-3.8852984 4.11779865c-.10668674.11373227-.13746009.28479112-.07777975.43222866.05898587.14785194.1968366.24275161.34814253.23966657h.13702605c.81156577-.00156555 1.61553587.16525712 2.36672677.49116683.1386754.06054976.2980545.02638404.4036995-.08642732l2.7889598-2.95478264c.8683381-.9211853 2.2761863-.9211853 3.1445244 0 .868338.92118529.868338 2.41471555 0 3.33590084l-3.4741769 3.68165615-.0296448.0353629-1.2148312 1.2809384c-.8676436.9192974-2.2731915.9192974-3.1408351 0-.58473705-.5838103-1.4968262-.5838103-2.08151988 0-.25317484.2691357-.40582629.6264944-.42965502 1.0058629-.02708402.4500943.12938697.8908874.42965502 1.2102126.42870013.4567248.93027538.8291865 1.48150466 1.1001639.07777976.0392768.15555952.0707259.23333922.1060888.0777798.0353629.1592489.062852.2370286.094301.0777798.0314491.1592489.0589382.2370286.0825135l.2185386.062852c.1481374.0392768.2963183.0707259.448145.098215.182904.0288244.3671101.0471966.5518804.0550243h.2592514.0222228l.2222278-.0274891c.0814691-.0039139.1666709-.0235753.2629841-.0235753h.1259147l.2555621-.0392768.118536-.0235752.2148058-.0471506h.0407562c.9097887-.2424293 1.740539-.7421606 2.4037503-1.4459653l4.7149202-5.00187131c2.0252251-2.14834261 2.0252251-5.63149681.0001302-7.77983943z"/></g></svg>
              Share Link
          </div>
          <a class="share-link uppercase" :href="'mailto:?subject=Check out this property!&body=Check out this property for sale on the Hamilton County Landbank website: '+ copyURL">
            <svg height="20" viewBox="0 0 21 20" width="21" xmlns="http://www.w3.org/2000/svg"><path d="m10.4987411.5124 10.3614203 6.46107737h-20.7228405zm10.4905251 16.7786066h-.0010506c0 1.0363405-.8398817 1.8761055-1.8761054 1.8761055h-17.2267381c-1.03634047 0-1.87610543-.8398817-1.87610543-1.8761055v-9.9064016c0-.10961069.0112062-.21618636.02941628-.32089434l9.89974796 6.17310124c.01214006.0075876.02509723.0127237.03758748.0197276.01307391.0072374.02638131.0142412.03968861.0208949.0699221.03607.1419453.0651361.2156027.0841633.0075876.0021011.0151751.003035.0227626.004786.0807781.0190272.1626067.0309338.2443187.0309338h.0005836.0011673c.0817119 0 .1635406-.0115564.2443186-.0309338.0075876-.0018677.0151751-.0026849.0227626-.004786.0735408-.0190272.1453305-.0480933.2156027-.0841633.0133074-.0066537.0266148-.0136575.0396887-.0208949.0123735-.0070039.0254474-.01214.0375875-.0197276l9.8997479-6.17310124c.0182101.10470798.0294163.21105019.0294163.32089434z" fill="#dc3b43" transform=""/></svg>
                Email
          </a>
          <a class="share-link uppercase" href="javascript:window.print()">
            <svg height="21" viewBox="0 0 24 21" width="24" xmlns="http://www.w3.org/2000/svg"><g fill="#dc3b43" transform=""><path d="m6 16.8v4.2h12v-4.2-2.8h-12zm1.5-1.4h9v1.4h-9zm0 2.8h9v1.4h-9z"/><path d="m18 4.2v-4.2h-12v4.2 2.8h12z"/><path d="m21 4h-1.5v2.88888889 1.44444444h-15v-1.44444444-2.88888889h-1.5c-1.5 0-3 1.44444444-3 2.88888889v7.22222221c0 1.4444445 1.5 2.8888889 3 2.8888889h1.5v-2.8888889-1.4444444h15v1.4444444 2.8888889h1.5c1.5 0 3-1.4444444 3-2.8888889v-7.22222221c0-1.44444445-1.5-2.88888889-3-2.88888889z"/></g></svg>                
            Print
          </a>
        </div>
      </div>
    <!-- end Desktop Grid/Map links, share links -->

    <!-- Mobile title and back button -->
    <div class="header mobile" v-if="!loading">
            <h2>{{ propertyData.parcel_address }}</h2>
            <router-link to="/available-properties/" class="back"><svg height="18" viewBox="0 0 24 18" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m10.1107238 1.73498565v3.67853963l.9103789.00841001c6.3235129.05971109 9.8848533 2.80305729 10.8133364 8.36291681-3.4734061-3.91990701-7.4787286-3.92158902-10.8038532-3.92243002h-.9198621v3.64742262l-8.52100904-5.88785004zm.9198621-1.73498565-11.0305859 7.62199466 11.0305859 7.62199464v-4.4842188c4.4148206.001682 8.5080775.2186603 11.9694141 6.2402295 0-3.8240328-.6474381-12.36776492-11.9694141-12.47457208z" fill="#dc3b43" stroke="#dc3b43" transform="translate(0 1)"/></svg> Back</router-link>
    </div>
    <!-- end Mobile title and back button -->
      
    <!-- Property Details -->
    <div class="property-details">
        <double-bounce v-if="loading"></double-bounce>
      <div class="row info" v-if="!loading">
        <div class="col-lg-6 content">
            <h2 class="desktop">{{ propertyData.parcel_address }}</h2>
            <div v-if="propertyData.suggested_listing_price" class="item">
                <p class="price large">${{ formatPrice(propertyData.suggested_listing_price) }}</p>
                <p class="disclaimer" style="margin-top: .5rem;">All prices are preliminary and subject to change. Final sale price will be determined based on proposed use, location, surrounding property values, condition of the property, and proposed project timeline.</p>
            </div>
            <!--
            <div v-if="displayBanner" class="banner">
                <i class="far fa-flag"></i><p>This property is marked for having one of the following characteristics: negligible acreage, limited road frontage or unusual shape. This property may be of best use to an adjacent land owner.</p>
            </div>
            -->
            <p v-if="propertyData.listing_desc" class="description">{{ propertyData.listing_desc }}</p>
           
            <div class="row">
                <div class="col-sm-6">
                    <div class="item">
                        <p class="label">Neighborhood:</p>
                        <p>{{ propertyData.neighborhood }}</p>
                    </div>
                    <div class="item">
                        <p class="label">Acres:</p>
                        <p>{{ propertyData.deed_acre }}</p>
                    </div>
                    <div class="item">
                        <p class="label">Parcel Number:</p>
                        <p>{{ propertyData.ppn }}</p>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="item">
                        <p class="label">Property Type:</p>
                        <p :class="propertyData.hclrc_prop_type">{{ propertyData.hclrc_prop_type }}</p>
                    </div>
                    <div class="item">
                        <p class="label">Zoning:</p>
                        <p>{{ propertyData.zoning }}</p>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="item">
                        <p class="label">Application Type:</p>
                        <p>{{ applicationType }} - {{ propertyData.app_type }}</p>
                        <a href="/how-we-help/our-programs/" class="inline-link" styl="text-decoration:underline">Learn More about our programs and corresponding application types</a>
                    </div>
                </div>
            </div>
            <div class="buttons">
                <div v-if="propertyData.mls_link" class="mls-notice">
                    <p>This property does not follow the traditional Landbank application process. Please see the project listing for more information:</p>
                    <a :href="propertyData.mls_link" class="btn btn-primary btn-xs" target="_blank">View Listing</a>
                </div>
                <div v-else>
                  <!-- <div class="mls-notice">
                        <p>Our online applications are currently unavailable. You can still apply for this property by filling out a paper application at the link below:</p>
                        <a href="/application-download/" class="btn btn-primary btn-xs">Application Download</a>
                    </div>-->
                    
                    <router-link  :to="{ name: 'ApplicationDetail', params: { property_id: propertyData.ppn }}" class="btn btn-primary btn-sm">Apply Online to Purchase this Property</router-link>
                    <a href="/application-download/" class="btn btn-outline-primary btn-sm">Download a Paper Application</a>
                    <a href="/how-we-help/resources/" class="btn btn-outline-primary btn-sm">Questions? View our resources</a>
                </div>
                
                <a :href="'https://wedge.hcauditor.org/view/re/' + propertyData.ppn + '/'" target="_blank">Hamilton County Auditor</a>
            </div>
            
        </div>

        <!-- Photo Gallery with Mapbox -->
        <div class="col-lg-6">
            <div class="mapLoading" v-if="loadingSimilarProperties" style="text-align: center;">
                <double-bounce></double-bounce>
                <p style="margin: 3rem 0;">Loading Map...</p>
            </div>
            <slick ref="slick" :options="slickOptions" class="main-slick">
                <div class="slide">
                    <div id="map"></div>
                </div>
                <div class="slide" v-for="image in propertyImages" :style="{'background-image': 'url(' + image + ')'}" v-bind:key="image"></div>
            </slick>
            <slick ref="slick" :options="slickNavOptions" class="nav-slick">
                <div class="slide">
                    <div id="mapThumb"></div>
                </div>
                <div class="slide" v-for="image in propertyImages" :style="{'background-image': 'url(' + image + ')'}" v-bind:key="image"></div>
            </slick>
        </div>
        <!-- end photo gallery with Mapbox -->
        
        </div> <!-- end row info -->

    
    
    <!-- Mobile share links, since they move to the bottom -->
    <div class="share-links mobile" v-if="!loading">
        <a class="share-link uppercase" href="" v-clipboard:copy="copyURL" v-on:click="alerts()">
            <svg height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><g fill="#dc3b43" transform=""><path d="m13.5670709 7.61102408c-.2634256-.28097325-.5555127-.53003655-.8708331-.74263135-.8351799-.56705761-1.8061112-.86838323-2.79784389-.86838323-1.37649214-.00271672-2.69705084.57718775-3.66867702 1.61101458l-4.7136941 5.00194082c-.96997597 1.0304654-1.51515318 2.4266289-1.51602172 3.8825142-.00182391 3.0381211 2.31941335 5.5025539 5.18469873 5.5044878 1.37436423.0050651 2.69370699-.5720766 3.66498576-1.6031407l3.89102104-4.1257297c.0706985-.0743184.1101733-.1757119.1096087-.2812495-.0011725-.2170152-.1680608-.3918983-.3727303-.390655h-.1482149c-.8129455.003039-1.6186387-.1624967-2.37165549-.4872137-.13874791-.0605506-.29821029-.0263844-.40391057.0864285l-2.79784392 2.9705254c-.86879205.9211981-2.27737642.9211981-3.14616847 0s-.86879205-2.4147491 0-3.3359472l4.73223725-5.01372856c.86809723-.91931019 2.27438-.91931019 3.1424772 0 .5850428.58381836 1.4976089.58381836 2.0826082 0 .2517005-.26711337.4043015-.62139199.4298797-.99804901.0270548-.45010054-.129498-.89089976-.4299231-1.21018335z"/><path d="m20.4811951 1.61125696c-2.0250948-2.14834261-5.3084248-2.14834261-7.3335197 0l-3.8852984 4.11779865c-.10668674.11373227-.13746009.28479112-.07777975.43222866.05898587.14785194.1968366.24275161.34814253.23966657h.13702605c.81156577-.00156555 1.61553587.16525712 2.36672677.49116683.1386754.06054976.2980545.02638404.4036995-.08642732l2.7889598-2.95478264c.8683381-.9211853 2.2761863-.9211853 3.1445244 0 .868338.92118529.868338 2.41471555 0 3.33590084l-3.4741769 3.68165615-.0296448.0353629-1.2148312 1.2809384c-.8676436.9192974-2.2731915.9192974-3.1408351 0-.58473705-.5838103-1.4968262-.5838103-2.08151988 0-.25317484.2691357-.40582629.6264944-.42965502 1.0058629-.02708402.4500943.12938697.8908874.42965502 1.2102126.42870013.4567248.93027538.8291865 1.48150466 1.1001639.07777976.0392768.15555952.0707259.23333922.1060888.0777798.0353629.1592489.062852.2370286.094301.0777798.0314491.1592489.0589382.2370286.0825135l.2185386.062852c.1481374.0392768.2963183.0707259.448145.098215.182904.0288244.3671101.0471966.5518804.0550243h.2592514.0222228l.2222278-.0274891c.0814691-.0039139.1666709-.0235753.2629841-.0235753h.1259147l.2555621-.0392768.118536-.0235752.2148058-.0471506h.0407562c.9097887-.2424293 1.740539-.7421606 2.4037503-1.4459653l4.7149202-5.00187131c2.0252251-2.14834261 2.0252251-5.63149681.0001302-7.77983943z"/></g></svg>
            Share Link
        </a>
        <a class="share-link uppercase" :href="'mailto:?subject=Check out this property!&body=Check out this property for sale on the Hamilton County Landbank website: '+ copyURL" target="_blank">
        <svg height="20" viewBox="0 0 21 20" width="21" xmlns="http://www.w3.org/2000/svg"><path d="m10.4987411.5124 10.3614203 6.46107737h-20.7228405zm10.4905251 16.7786066h-.0010506c0 1.0363405-.8398817 1.8761055-1.8761054 1.8761055h-17.2267381c-1.03634047 0-1.87610543-.8398817-1.87610543-1.8761055v-9.9064016c0-.10961069.0112062-.21618636.02941628-.32089434l9.89974796 6.17310124c.01214006.0075876.02509723.0127237.03758748.0197276.01307391.0072374.02638131.0142412.03968861.0208949.0699221.03607.1419453.0651361.2156027.0841633.0075876.0021011.0151751.003035.0227626.004786.0807781.0190272.1626067.0309338.2443187.0309338h.0005836.0011673c.0817119 0 .1635406-.0115564.2443186-.0309338.0075876-.0018677.0151751-.0026849.0227626-.004786.0735408-.0190272.1453305-.0480933.2156027-.0841633.0133074-.0066537.0266148-.0136575.0396887-.0208949.0123735-.0070039.0254474-.01214.0375875-.0197276l9.8997479-6.17310124c.0182101.10470798.0294163.21105019.0294163.32089434z" fill="#dc3b43" transform=""/></svg>
            Email
        </a>
        <a class="share-link uppercase" href="javascript:window.print()">
        <svg height="21" viewBox="0 0 24 21" width="24" xmlns="http://www.w3.org/2000/svg"><g fill="#dc3b43" transform=""><path d="m6 16.8v4.2h12v-4.2-2.8h-12zm1.5-1.4h9v1.4h-9zm0 2.8h9v1.4h-9z"/><path d="m18 4.2v-4.2h-12v4.2 2.8h12z"/><path d="m21 4h-1.5v2.88888889 1.44444444h-15v-1.44444444-2.88888889h-1.5c-1.5 0-3 1.44444444-3 2.88888889v7.22222221c0 1.4444445 1.5 2.8888889 3 2.8888889h1.5v-2.8888889-1.4444444h15v1.4444444 2.8888889h1.5c1.5 0 3-1.4444444 3-2.8888889v-7.22222221c0-1.44444445-1.5-2.88888889-3-2.88888889z"/></g></svg>                
        Print
        </a>
    </div>
    <!-- end mobile share links -->

    <!-- Similar Properties -->
    <div class="similar-properties">
        <h3>Similar Properties You May Like:</h3>
        <div class="property-grid">
        <router-link class="property-item" v-for="property in similarPropertyData" :to="'/available-properties/' + property.ppn + '/'" v-bind:key="property.ppn">
                <div v-if="property.main_pic_link" class="image" :style="{'background-image': 'url(' + property.main_pic_link + ')'}"></div>
                <div v-else class="image" style="background-image:url('/assets/images/default house image@2x.png')"></div>
                <p :class="'address ' + property.hclrc_prop_type">{{ property.parcel_address }}</p>
                <p class="price"><strong>Price:</strong> ${{ formatPrice(property.suggested_listing_price) }}</p>
                <p class="neighborhood"><strong>Neighborhood:</strong> {{ property.neighborhood }}</p>
                <p :class="'type ' + property.hclrc_prop_type">{{ property.hclrc_prop_type }}</p>
        </router-link>
        </div>

    </div> <!-- end Similar Properties -->

        


    </div>
    
      <p class="disclaimer light">
            DISCLAIMER: All information on this list is subject to change.  Therefore, the HCLRC or the Port of Greater Cincinnati Development Authority do not guarantee the accuracy of this information and each user utilizes this information at his or her own risk. The HCLRC nor the Port of Greater Cincinnati Development Authority are not responsible for, and expressly disclaim all liability for, damages of any kind arising out of use, reference to, or reliance on any information contained herein. By utilizing this site, the user agrees to these terms and agrees to hold the HCLRC and the Port of Greater Cincinnati Development Authority harmless from all claims arising out of use, reference to, or reliance on any information contained herein.
    </p>
      
  </div>
</template>

<script>
import axios from 'axios';
import {DoubleBounce} from 'vue-loading-spinner';
import Slick from 'vue-slick';



export default {
  name: 'PropertyDetail',
  components: {
    DoubleBounce,
    Slick,
  },
  data() {
    return {
        propertyData: [],
        similarPropertyData: [],
        loading: true,
        loadingSimilarProperties: true,
        copySucceeded: null,
        displayBanner: false,
        accessToken: "pk.eyJ1Ijoiam1vbGxtYW4iLCJhIjoiY2tlZWo5bXR6MDB0ODJ5cXRmMGF3Z292dyJ9.1p8JgVqMKvSMjdVnJLuALw",
        map: '',
        mapThumb: '',
        title: 'Available Properties',
        propertyImages: [],
        slickOptions: {
            //options for main slider
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: false,
            asNavFor: '.nav-slick',
        },
        slickNavOptions: {
            // options for thumbnail slider
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: false,
            focusOnSelect: true,
            asNavFor: '.main-slick',
        }
    }
  },
  created: function(){
      window.scrollTo(0,0);
      this.getPropertyDetails();
  },

  
  computed: {
      /**
       * Retrieves URL to allow user to copy it
       */
      copyURL() {
          return 'https://hamiltoncountylandbank.com' + this.$route.fullPath;
      },

      /**
       * Sets Application Type based on PPS fileds
       */
      applicationType() {
          let type = '';
          if (this.propertyData.no_lty == undefined) {
              type += 'Lot-to-Yard';
          }
          if (this.propertyData.no_g_and_g == undefined) {
              if (type != '') {
                  type += ', '
              }
              type += 'Gardens and Greens';
          }
          if (this.propertyData.no_sfhd == undefined) {
              if (type != '') {
                  type += ', '
              }
              type += 'Single Family Home';
          }
          if (this.propertyData.no_cd == undefined) {
              if (type != '') {
                  type += ', '
              }
              type += 'Commercial';
          }
          return type;
      },

      /**
       * Formats Map point as geoJSON for Mapbox
       */
      filteredGeoJSON() {
        let newItem = {};
        newItem['type'] = 'Feature';
        newItem['properties'] = {
          "ppn" : this.propertyData.ppn,
          "hclrc_prop_type" : this.propertyData.hclrc_prop_type,
        };
        newItem['geometry']= {
          "type" : "Point",
          "coordinates" : [
            this.propertyData.longitude, this.propertyData.latitude
          ]
        };
        return [newItem];

    },
  },
  methods: {
      /**
      * Informs user that the URL has been copied to their clipboard
       */
      alerts() {
          alert('Copied to clipboard!');
      },
      formatPrice: function(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    displayTooltip(event) {
          this.$parent.displayTooltip(event);
      },

    goToGrid() {
        this.$router.go(-1)
    },

      /**
      * Retrieves property detail data from PPS API
      */
      getPropertyDetails() {
            this.$set(this, 'loading', true);

            axios.get('/wp-json/HCLRC/v1/publish-hclrc-parcel-detail/', {
                params: {
                'ppn' : window.location.pathname.substring(22, window.location.pathname.length - 1) 
                }
            })
            .then((response) => {

                    this.$set(this, 'propertyData', response['data']['data']['data']['parcel_detail']['data'][0]);
                    this.$set(this, 'propertyImages', response['data']['data']['data']['public_pictures']);
                    this.propertyImages.push(this.propertyData.main_pic_link);
                    this.$set(this, 'loading', false);
                    var acres = parseFloat(this.propertyData.deed_acre);
                    var frontage = parseInt(this.propertyData.front);

                    // display banner if acres or frontage are under a certain amount
                    if (acres < 0.03) {
                        this.$set(this, 'displayBanner', true);
                    }
                    if (frontage == 0) {
                        this.$set(this, 'displayBanner', true);
                    }
                    this.getSimilarProperties();

            })
            .catch(function (error) {
                // if an error occurs, print that error
                console.log(error);
            });
      },

      /**
       *  get similar properties (those in the same neighborhood) from PPS API
       */
      getSimilarProperties() {
        this.$set(this, 'loadingSimilarProperties', true);

          // Get similar properties data from API
            axios.get('/wp-json/HCLRC/v1/publish-hclrc-parcels/')
            .then((response) => {
                // Once this data has been received, create the map
                this.createMap();
                
                var allData = response.data.data.data.data;
                var count = 0;
                    for (var item of allData) {
                        if (count >= 4) {
                            break;
                        } else {
                            if (item.neighborhood == this.propertyData.neighborhood && item.ppn != this.propertyData.ppn) {
                                this.similarPropertyData.push(item);
                                count++;
                            }
                        }
                    
                    }
                    this.$set(this, 'loadingSimilarProperties', false);

                
            })
            .catch(function (error) {
            // if an error occurs, print that error
            console.log(error);
            });

      },

      /**
       * Create both Mapbox objects
       */
      createMap() {
        mapboxgl.accessToken = this.accessToken;    
        // init the map
        var map = new mapboxgl.Map({
            // ID of container 
            container: 'map',
            // Style URL
            style: 'mapbox://styles/mapbox/streets-v11',
            // Center of the map
            center: [this.propertyData.longitude, this.propertyData.latitude],
            zoom: 15,
            interactive: false,
        });

        // Don't allow zoom on scorll
        map.scrollZoom.disable();

        // Add navigation to the top left corner
        var nav = new mapboxgl.NavigationControl();
        map.addControl(nav, 'top-left');

        this.$set(this, 'map', map);

        // Once map has loaded...
        this.map.on('load', function(e) {
            // Add layer to the map
            this.map.addLayer({
              "id": 'locations',
              "type": 'circle',
              // Add a GeoJSON source containing place coordinates and information.
              "source": {
                "type": 'geojson',
                "data": {
                  "type": "FeatureCollection",
                  "features": this.filteredGeoJSON
                }
              },
              // Add icon marker from Mapbox 
              'paint': {
                  // make circles larger as the user zooms from z12 to z22
                  'circle-radius': {
                      'base': 10,
                      'stops': [[20, 10], [25, 180]]
                  },
                  // color circles by property type, using a match expression
                  // https://www.mapbox.com/mapbox-gl-js/style-spec/#expressions-match
                  'circle-color': [
                      'match', ['get', 'hclrc_prop_type'],
                      'Residential Land', '#fdbb48',
                      'Residential Building', '#fdbb48',
                      'Commercial Land', '#e53d51',
                      'Commercial Building', '#e53d51',
                      'Industrial Land', '#533278',
                      /* default */ '#000000',
                  ]
              }
              
              
            });
        }.bind(this));


        // init the mapThumb
        var mapThumb = new mapboxgl.Map({
            // ID of container 
            container: 'mapThumb',
            // Style URL
            style: 'mapbox://styles/mapbox/streets-v11',
            // Center of the map
            center: [this.propertyData.longitude, this.propertyData.latitude],
            zoom: 10,
            interactive: false,
            attributionControl: false,
            
        });

        // Don't allow zoom on scorll
        mapThumb.scrollZoom.disable();

        this.$set(this, 'mapThumb', mapThumb);

        // Once map has loaded...
        this.mapThumb.on('load', function(e) {
            // Add layer to the map
            this.mapThumb.addLayer({
              "id": 'locations',
              "type": 'circle',
              // Add a GeoJSON source containing place coordinates and information.
              "source": {
                "type": 'geojson',
                "data": {
                  "type": "FeatureCollection",
                  "features": this.filteredGeoJSON
                }
              },
              // Add icon marker from Mapbox 
              'paint': {
                  // make circles larger as the user zooms from z12 to z22
                  'circle-radius': {
                      'base': 1.5,
                      'stops': [[15, 1.75], [25, 2]]
                  },
                  // color circles by property type, using a match expression
                  // https://www.mapbox.com/mapbox-gl-js/style-spec/#expressions-match
                  'circle-color': [
                      'match', ['get', 'hclrc_prop_type'],
                      'Residential Land', '#fdbb48',
                      'Residential Building', '#fdbb48',
                      'Commercial Land', '#e53d51',
                      'Commercial Building', '#e53d51',
                      'Industrial Land', '#533278',
                      /* default */ '#000000',
                  ]
              }
              
              
            });
      }.bind(this));
    },
  
},
watch: {
    '$route' (to, from) {
        window.scrollTo(0,0);
        this.$set(this, 'similarPropertyData', []);
        this.getPropertyDetails();
        this.getSimilarProperties();
    }
}
 

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.property-details {
    .spinner {
    position: absolute !important;
    left: 0;
    margin: 0 auto;
    right: 0;
}
}

.mapLoading.spinner {
    margin-top: 2rem;

}

.banner {
    background-color: #dc3b43;
    padding: 1rem;
    display: flex;
    margin-bottom: 1rem;
    p {
        font-size: 1rem;
        color: #fff;
        font-family: "neue-haas-unica";
        font-weight: 600;
        margin-bottom: 0;
    }
    i {
        color: #fff;
        margin-right: .5rem;
        margin-top: .25rem;
    }
}

.top-links {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .view-links {
    display: flex;
    margin-bottom: 2rem;

        .link {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 2rem;
            font-family: 'din-2014';
            font-weight: 600;
            color: #276AA6 !important;


            svg {
                margin-right: .5rem;
            }
        }
    }
}
.share-links {
    display: flex;
    .share-link {
        font-family: 'din-2014';
        font-weight: 600;
        margin-left: 2.75rem;
        cursor: pointer;
        display: flex;

        svg {
            margin-right: .25rem;
        }
    }
    
} 

.infoLabel {
    .fa-info-circle {
        background-color: unset;
    }
}

.description {
    margin-top: 2rem;
}

@media screen and (max-width: 768px) {
    .description {
        margin-top: 1rem;
    }
}

.property-details {
    text-align: left;
    border-top: 1px solid #E5E5E5;
    padding-top: 1.5rem;
    a {
        color: #E22A40;
        text-decoration: underline;
    }
    p.price.large {
        font-size: 1.5rem;
        font-weight: 400;
    }
    .info {
        p {
            &.label {
                font-family: 'din-2014';
                font-weight: 700;
                font-size: 1.375rem;
                margin-bottom: 0;
            }
            &.Residential {
                color: #A56A02; // had to change for ADA
                &::before {
                        display: inline-block;
                        content: '';
                        width: .75rem;
                        height: .75rem;
                        border-radius: 1.25rem;
                        margin-right: .5rem;
                        background-color: #fdbb48;

                    }
            }
            &.Commercial {
                color: #E22A40; // had to change for ADA
                &::before {
                        display: inline-block;
                        content: '';
                        width: .75rem;
                        height: .75rem;
                        border-radius: 1.25rem;
                        margin-right: .5rem;
                        background-color: #e53d51;

                    }
            }
             &.Industrial {
                color: #533278;
                &::before {
                        display: inline-block;
                        content: '';
                        width: .75rem;
                        height: .75rem;
                        border-radius: 1.25rem;
                        margin-right: .5rem;
                        background-color: #533278;

                    }
            }
        }
        @media screen and (max-width: 992px) {
            flex-direction: column-reverse;
        }
    }
    .buttons {
        margin-top: 2rem;
        a:not(.btn) {
            text-decoration: underline;
            color: #DC3B43;
            margin-bottom: 1rem;
            width: fit-content;
        }
        a {
            display: block;

        }

        p {
            a {
                display: inline;
                text-transform: none;
                text-decoration: none;
                font-weight: 700;
            }
        }

        .btn {
            margin: 1rem 0;
            text-decoration: none;
            width: fit-content;
            text-align: left;
            min-width: 470px;

            &::before {
                font-family: 'Font Awesome 5 Free';
                content: "\f054";
                margin-right: .25rem;
            }

            @media screen and (max-width: 768px) {
                min-width: unset;
            }
        }
    }
}

.slide {
    height: 500px;
    background-size: cover;
    background-position: center;
    @media screen and (max-width: 600px) {
        height: 300px;
    }

}
.nav-slick {
    margin-top: 2rem;
    .slick-track {
        margin: 0;
    }
    .slide {
        height: 65px;
        width: 87px !important;
    }

    @media screen and (max-width: 600px) {
        margin-top: 1rem;
        .slide {
            height: 55px;
            width: 59px !important;
        }
    }
}
#map {
    width: 100%;
    height: 500px;
    @media screen and (max-width: 600px) {
        height: 300px;
    }
}
#mapThumb {
    width: 100%;
    height: 65px;

    @media screen and (max-width: 600px) {
        height: 55px;
    }
}

.similar-properties {
    margin-top: 6rem;
    h3 {
        font-size: 1.5rem;
    }
}

.disclaimer {
    font-size: .875rem;
    line-height: 1.5rem;
    margin-top: 2rem;

}

.mls-notice {
    border: 1px solid #DC3B43;
    padding: 1rem;
    margin: 2rem 0;
    .btn {
        margin: 0 !important;
    }
}

.mobile {
    display: none;
}




@media screen and (max-width: 992px) {
    .desktop {
        display: none;
    }
    .mobile {
        display: block;
        &.header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            h2 {
                width: 75%;
            }
            a {
                width: 25%;
                text-align: right;
                margin: 0;
            }
        }
        &.share-links {
            display: flex;
            justify-content: space-between;
            .share-link {
                margin-left: 0;
            }
        }
    }
    h2 {
        font-size: 1.375rem;
    }
    .similar-properties {
        border-top: 1px solid #E5E5E5;
        padding-top: 2rem;
        margin-top: 3rem;
        h3 {
            font-size: 1.125rem;
            text-align: center;
        }
        .property-grid {
            .property-item {
                margin-right: 0;
                width: 100%;
                max-width: 300px;
                text-decoration: none;
                &:focus {
                    text-decoration: underline;
                }
            }
            
        }
    }
    .property-details {
        margin-bottom: 3rem;
        .content {
            margin-top: 3rem;
        }
        .buttons {
            text-align: center;
            margin-bottom: 3rem;
            a {
                width: auto;
            }
        }
        
        .col-sm-6 {
            width: 50%;
            p.label {
                font-size: 1.125rem;

            }
            
        }
    }
    
}

</style>



// WEBPACK FOOTER //
// src/components/PropertyDetail.vue